import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Sig } from "./Brand";

const LINKED = /(Harbourfront Health & Wellness Centre|SKIN Medical Spa)/;

export const PressText = ({ children }) => children.split(LINKED).map((part, i) => (i % 2
  ? <Link key={i} to="/founders#press" data-testid="bio-press-link" className="border-b border-gold/70 hover:text-gold transition-colors">{part}</Link>
  : <Sig key={i}>{part}</Sig>));

const PRESS = [
  { id: "pr2007", pub: "Press release", date: "September 30, 2007", title: "New Concept: SKIN Medical Spa Takes a Psychological Approach to Stress-Free Healthy Skin", pages: ["/press/press-release-2007.jpg"] },
  { id: "star", pub: "Toronto Star", date: "March 2007", title: <>“Heaven on Earth” Beauty is not skin deep — holistic treatments and eco-friendly retreats</>, pages: ["/press/toronto-star-2007-1.jpg", "/press/toronto-star-2007-2.jpg"] },
  { id: "pr2006", pub: "Press release", date: "September 10, 2006", title: "New Concept: SKIN Medical Spa Educates Healthy Skin Inside Out, from East to West", pages: ["/press/press-release-2006-sage.jpg"] },
];

function Lightbox({ item, onClose }) {
  return (
    <div className="fixed inset-0 z-[80] bg-black/90 overflow-y-auto" onClick={onClose} data-testid="press-lightbox">
      <button onClick={onClose} aria-label="Close" data-testid="press-lightbox-close" className="fixed top-5 right-5 z-10 w-11 h-11 flex items-center justify-center bg-ink border border-goldbright text-goldbright"><X size={20} /></button>
      <div className="max-w-4xl mx-auto px-4 py-16 space-y-6" onClick={(e) => e.stopPropagation()}>
        {item.pages.map((src) => <img key={src} src={src} alt={`${item.pub}, ${item.date}: ${item.title}`} className="no-grade w-full h-auto bg-white" />)}
      </div>
    </div>
  );
}

export default function PressCards() {
  const [open, setOpen] = useState(null);
  return (
    <section id="press" className="px-6 lg:px-10 max-w-7xl mx-auto py-14 border-t border-gold/40 scroll-mt-24" data-testid="press-section">
      <p className="eyebrow mb-3" data-testid="press-eyebrow">Media</p>
      <h2 className="font-display text-3xl lg:text-4xl tracking-tight mb-10" data-testid="press-heading">In the press</h2>
      <div className="grid md:grid-cols-3 gap-8">
        {PRESS.map((p) => (
          <button key={p.id} type="button" onClick={() => setOpen(p)} className="text-left border border-gold/40 p-7 flex flex-col hover:border-gold hover:bg-white/[0.04] transition-colors" data-testid={`press-card-${p.id}`}>
            <img src={p.pages[0]} alt={`${p.pub}, ${p.date}, first page`} loading="lazy" data-testid={`press-thumb-${p.id}`} className="no-grade w-full h-40 object-cover object-top bg-white mb-5" />
            <p className="eyebrow !text-[0.58rem]">{p.pub} · {p.date}</p>
            <h3 className="mt-4 mb-6 font-headline text-xl text-ivory/90 leading-snug">{p.title}</h3>
            <span className="mt-auto w-fit eyebrow !text-[0.55rem] !text-ivory/70 border-b border-gold/70 pb-0.5" data-testid={`press-read-${p.id}`}>Read the clipping</span>
          </button>
        ))}
      </div>
      {open && <Lightbox item={open} onClose={() => setOpen(null)} />}
    </section>
  );
}
